import classNames from "classnames";
import React from "react";
import { DetailTransactionCancelItemType } from "sagas/types/detailTransactions";
import { ReasonListPropsType } from "./types";

export const ReasonList: React.FC<ReasonListPropsType> = ({
  messages,
  selectedMessage,
  handleClick,
}): JSX.Element => {
  return (
    <div className="reason-canceled-scroll">
      <div className="reason-cancelled-content">
        <hr className="reason-canceled-separate" />
        {messages &&
          messages.map((message: DetailTransactionCancelItemType) => (
            <div
              key={message.id}
              className={classNames("modal-transaction-reason-container", {
                "selected":
                  selectedMessage && selectedMessage.id === message.id,
              })}
            >
              <p
                onClick={() => {
                  handleClick(message);
                }}
                data-value={message.id}
              >
                {message?.message}
              </p>
            </div>
          ))}
      </div>
    </div>
  );
};
